import Home from '../spa/Home'
import Login from '../spa/login/Login'
import DataParams from '../spa/references/DataParameters'
import CountersModels from '../spa/references/CountersModels'
import CountersModelsAPI from '../spa/references/CountersModelsAPI'
import CountersModelsResourceTypes from '../spa/references/CountersModelsResourceTypes'
import CountersModelsParameters from '../spa/references/CountersModelsParameters'
import DataSources from '../spa/references/DataSources'
import Represents from '../spa/Represents'
import Customers from '../spa/customers/Customers'
import RepresentNew from '../spa/RepresentNew'
import Points from '../spa/points/Points'
import Report008 from '../spa/reports/Report008'
import Report00102 from '../spa/reports/Report00102'
import Report80020 from '../spa/reports/Report80020'
import Report010 from '../spa/reports/Report010'
import PointCountersData from '../spa/points/PointCountersData'
import PointEdit from '../spa/points/PointEdit'
import PointCounters from '../spa/points/counters/PointCounters'
import PointConsumption from '../spa/points/PointConsumption'
import PointCounterPhase from '../spa/points/PointCounterPhase'
import Counters from '../spa/counters/Counters'
import PointProfile from '../spa/points/PointProfile'
import PointScheduler from '../spa/points/PointScheduler'
import Tasks from '../spa/Tasks'
import Monitoring from '../spa/Monitoring'
import Users from '../spa/user/Users'
import PermissionsGroups from '../spa/permissions-groups/PermissionsGroups'
import ReleaseNotes from '../ReleaseNotes'
import DocumentsRequests from '../spa/documents-requests/DocumentsRequests'
import DocumentsRequestsType from '../spa/documents-requests/DocumentsRequestsType'
import DocumentsRequestsRequired from '../spa/documents-requests/DocumentsRequestsRequired'
import AccountEmails from '../spa/account-settings/AccountEmails'
import AccountSettings from '../spa/account-settings/AccountSettings'
import NotFound from '../spa/NotFound'

export const routes = [
  {
    path: '/',
    component: Home
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/data_params',
    component: DataParams,
    name: 'Типы параметров'
  },
  {
    path: '/counters_models',
    component: CountersModels,
    name: 'Модели приборов учета'
  },
  {
    path: '/counters_models_api',
    component: CountersModelsAPI,
    name: 'Группы моделей приборов учета'
  },
  {
    path: '/counters_resource',
    component: CountersModelsResourceTypes,
    name: 'Ресурс'
  },
  {
    path: '/counter_model_parameters',
    component: CountersModelsParameters,
    name: 'Параметры модели'
  },
  {
    path: '/data_sources',
    component: DataSources,
    name: 'Источники данных'
  },
  {
    path: '/counters',
    component: Counters,
    name: 'Счетчики'
  },
  {
    path: '/represents/:representId',
    component: Represents,
    name: 'Объекты'
  },
  {
    path: '/represent/:parentId/new',
    component: RepresentNew,
    name: 'Добавить дочерний объект'
  },
  {
    path: '/represent/new',
    component: RepresentNew,
    name: 'Добавить объект'
  },
  {
    path: '/points',
    component: Points,
    name: 'Точки учёта',
    children: [
      {
        path: ':id/point_counters_data',
        component: PointCountersData,
        name: 'Данные по ТУ'
      }
    ]
  },
  {
    path: '/points/:id/edit',
    component: PointEdit,
    name: 'Редактирование точки учёта'
  },
  {
    path: '/points/:id/counters',
    component: PointCounters,
    name: 'Счетчики по точке учёта'
  },
  {
    path: '/points/:id/scheduler',
    component: PointScheduler,
    name: 'Расписание'
  },
  {
    path: '/points/:id/consumption',
    component: PointConsumption,
    name: 'Потребление'
  },
  {
    path: '/points/:id/phase',
    component: PointCounterPhase,
    name: 'Фазы'
  },
  {
    path: '/points/:id/profile',
    component: PointProfile,
    name: 'Профиль мощности'
  },
  {
    path: '/tasks',
    component: Tasks,
    name: 'Задания'
  },
  {
    path: '/monitoring',
    component: Monitoring,
    name: 'Мониторинг'
  },
  {
    path: '/customers',
    component: Customers,
    name: 'Абоненты'
  },
  {
    path: '/report-008',
    component: Report008,
    name: 'Форма 008'
  },
  {
    path: '/report-00102',
    component: Report00102,
    name: 'Форма 001.02'
  },
  {
    path: '/report-80020',
    component: Report80020,
    name: 'Форма 80020'
  },
  {
    path: '/report-010',
    component: Report010,
    name: 'Форма 010'
  },
  {
    path: '/users',
    component: Users,
    name: 'Пользователи'
  },
  {
    path: '/permissions-groups',
    component: PermissionsGroups,
    name: 'Права'
  },
  {
    path: '/documents-requests',
    component: DocumentsRequests,
    name: 'Поступившие заявки'
  },
  {
    path: '/documents-requests-types',
    component: DocumentsRequestsType,
    name: 'Типы заявок'
  },
  {
    path: '/documents-requests-required',
    component: DocumentsRequestsRequired,
    name: 'Требуемые файлы заявок'
  },
  {
    path: '/release-notes',
    component: ReleaseNotes,
    name: 'Информация о релизах'
  },
  {
    path: '/account-emails',
    component: AccountEmails,
    name: 'Email адреса акаунта'
  },
  {
    path: '/account-settings',
    component: AccountSettings,
    name: 'Настройки аккаутнта'
  },
  {
    path: '*',
    component: NotFound
  }
]

export const VueRouterObject = {
  routes,
  mode: 'history',
  saveScrollPosition: true
}

export default VueRouter => new VueRouter(VueRouterObject)



// WEBPACK FOOTER //
// ./src/config/router.js